import { useEffect, useRef } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../UI/card"
import { Tooltip, TooltipProvider, TooltipTrigger } from "../UI/tooltip"
import { useDispatch } from "react-redux";
import { updateBehaviorPercentage } from "../../Actions/GamesReportsStatusActions/GamesReportsStatusActions";
import Slider from "../UI/slider";
import HorizontalBarBYChartJS from "./newDesign/horizantalBarByCharts";

export const AnimatedDiv = ({ className, style, width, duration = 1, delay = 0, height }) => {
  const divRef = useRef(null);

  useEffect(() => {
    const element = divRef.current;

    if (element && width) {
      // Apply initial styles
      element.style.transition = `width ${duration}s ease-in-out ${delay}s`;
      element.style.width = width;
    }
    return () => {
      element.style.width = '0%';

    }
  }, [width, duration, delay]);

  useEffect(() => {
    const element = divRef.current;

    if (element && height) {
      // Apply initial styles
      element.style.transition = `height ${duration}s ease-in-out ${delay}s`;
      element.style.height = height;
    }
    return () => {
      element.style.height = '0%';

    }
  }, [height, duration, delay]);

  return <div ref={divRef} className={className} style={{ ...style, width: 0, height: 0 }} />;
};

const BehaviorBar = ({ label, percentage, colorClass, index, original_variable_name }) => {
  const dispatch = useDispatch();

  const handleChangeValue = (value) => {
    // let value = +event.target.value
    dispatch(updateBehaviorPercentage({ label, value, modified_features: { [label]: value } }))
  }
  return (
    <div className="mb-6 last:mb-0 relative">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-800">{label}</span>
        <span className={`text-sm font-bold text-${colorClass}-700`}>{percentage ? (+percentage).toFixed(2) : '0.00'}</span>
      </div>
      <TooltipProvider>
        <Tooltip className=''>
          <TooltipTrigger asChild>
            {/* <div className="relative h-8 bg-gray-200 rounded-full overflow-hidden">
              <AnimatedDiv
                className={`absolute top-0 left-0 h-full bg-${colorClass}-500 rounded-full`}
                width={`${percentage}%`}
                duration={1}
                delay={index * 0.2}
              />
            </div> */}
            {/* <div className="mb-4">
              <input type="range" id="price-range" className={`w-full accent-${colorClass}-500 cursor-pointer`} min="0" max="100" value={percentage} onChange={handleChangeValue} />
            </div> */}
            <Slider disabled onChange={handleChangeValue} initialValue={percentage} />
          </TooltipTrigger>
          {/* <TooltipContent className='absolute bottom-8 opacity-0 group-hover:opacity-100 bg-white'>
            <p>You performed this behavior more than {percentage}% of a nationally representative sample</p>
          </TooltipContent> */}
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}

export function HorizontalBarChart({ data, colorClass, isUpdateBehaviors, isLoading, handleReset = () => { }, infoIcon }) {
  return (
    <Card className={`w-full border-${colorClass}-200 bg-${colorClass}-50`}>
      <CardHeader className='!flex-row justify-between items-center relative'>
        <CardTitle className={`text-${colorClass}-900`}>Behaviors</CardTitle>
        {
          isUpdateBehaviors && (
            <button
              className={`bg-${colorClass}-900 text-white px-4 py-2 text-bold rounded-md px-4 py-2`}
              onClick={handleReset}
            >
              Reset
            </button>
          )

        }
        {infoIcon}
      </CardHeader>
      <CardContent className='min-h-[35rem]'>
        {
          isLoading ? (
            <div className=" w-full gap-3">
              {
                [...Array(5)].map((_, index) => (
                  <div key={index} className="h-20 !w-full ">
                    <div className="flex justify-between items-center mb-2">
                      <span className="bg-gray-200 dark:bg-neutral-300 px-8 py-3 rounded-md animate-pulse"></span>
                      <span className="bg-gray-200 dark:bg-neutral-300 px-6 py-3 rounded-md animate-pulse"></span>
                    </div>
                    <div className="flex justify-between items-center mb-2">
                      <p className="w-[100vw] h-5 bg-gray-200  rounded-full dark:bg-neutral-300 animate-pulse !scale-x-100"></p>
                    </div>
                  </div>
                ))
              }
            </div>
          )
            :
            // data?.length ? <ProgressBars data={data} />

            data?.length ? <HorizontalBarBYChartJS data={data} />
            // data.map((item, index) => (
              //   <BehaviorBar key={item?.label} {...item} colorClass={colorClass} index={index} />
              // ))
              : <div className="flex items-center justify-center min-h-[35rem] text-black">
                <span>Oops! It looks like we don't have any behavioral data to show here right now.</span>
              </div>
        }
      </CardContent>
    </Card>
  )
}

const gradientColors = {
  "0": "#FF0000",
  "10": "#FF4500",
  "20": "#FF8C00",
  "30": "#FFA500",
  "40": "#FFD700",
  "50": "#FFFF00",
  "60": "#C8E600",
  "70": "#90CC00",
  "80": "#5FB300",
  "90": "#2F9900",
  "100": "#008000"
}

const getGradientStyle = (value) => {
  let stops = Object.keys(gradientColors)
    .map(Number)
    .filter((key) => key <= value)
    .map((key) => gradientColors[key]);

  if (stops.length === 1) {
    stops.push(gradientColors[10]);
  }

  return `linear-gradient(to right, ${stops.join(", ")})`;
};

const ProgressBar = ({ label, percentage }) => {
  return (
    <div className="w-full my-3">
      <div className="mb-1 flex justify-between font-bold text-gray-700">
        <span>{label} </span>
        <span>{(+percentage).toFixed(2)}</span>
      </div>
      <div className="w-full h-9 bg-transparent border border-gray-400 rounded-full overflow-hidden relative">
        <div
          className={`h-full text-white font-bold text-sm flex items-center rounded-full justify-end pr-2 transition-all duration-500 `}
          style={{ width: `${+percentage}%`, background: getGradientStyle(+percentage), }}
        >
        </div>
      </div>
    </div>
  );
};

const ProgressBars = ({ data }) => {
  // const progressData = [
  //   { label: "Graph 01", percentage: 25 },
  //   { label: "Graph 02", percentage: 50 },
  //   { label: "Graph 03", percentage: 75 },
  //   { label: "Graph 04", percentage: 90 },
  //   { label: "Graph 05", percentage: 100 },
  // ];

  return data.map((progress, index) => (
    <ProgressBar key={index} {...progress} />
  ));
};